import { render, staticRenderFns } from "./PartneredUser.vue?vue&type=template&id=19f95c8b&"
import script from "./PartneredUser.vue?vue&type=script&lang=ts&"
export * from "./PartneredUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports